import { useState, useEffect } from 'react';
import axios from 'axios';

export const useShippingSettings = () => {
  const [settings, setSettings] = useState({
    freeShippingThreshold: 300,
    shippingCost: 25,
    taxRate: 18,
    taxIncluded: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get('/api/admin/settings/tax');
      setSettings(response.data.settings || settings);
    } catch (error) {
      console.error('Error fetching shipping settings:', error);
      // Use default values if API fails
    } finally {
      setLoading(false);
    }
  };

  const calculateShipping = (subtotal) => {
    return subtotal >= settings.freeShippingThreshold ? 0 : settings.shippingCost;
  };

  const calculateTax = (subtotal) => {
    // If tax is included in prices, extract the tax amount (for display purposes)
    // If tax is not included, calculate tax to be added
    if (settings.taxIncluded) {
      // Extract tax from total: tax = subtotal × (taxRate / (100 + taxRate))
      return subtotal * (settings.taxRate / (100 + settings.taxRate));
    } else {
      // Calculate tax to add: tax = subtotal × (taxRate / 100)
      return subtotal * (settings.taxRate / 100);
    }
  };

  return {
    settings,
    loading,
    calculateShipping,
    calculateTax,
    refreshSettings: fetchSettings
  };
};
